import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M917.333 234.667V448H896a64 64 0 000 128h21.333v213.333H106.667V576H128a64 64 0 000-128h-21.333V234.667h810.666zm-42.666 42.666H149.333v130.134l5.974 1.365a106.752 106.752 0 0179.146 96.17l.214 6.998c0 49.493-33.707 91.093-79.36 103.168l-5.974 1.323v130.176h725.334V616.533l-5.974-1.365a106.752 106.752 0 01-79.146-96.17l-.214-6.998c0-49.493 33.707-91.093 79.36-103.168l5.974-1.408v-130.09zm-192.64 38.571l30.165 30.165-362.027 362.027L320 677.931l362.027-362.027zm-63.36 217.43a85.333 85.333 0 110 170.666 85.333 85.333 0 010-170.667zm0 42.666a42.667 42.667 0 100 85.333 42.667 42.667 0 000-85.333zM405.333 320a85.333 85.333 0 110 170.667 85.333 85.333 0 010-170.667zm0 42.667a42.667 42.667 0 100 85.333 42.667 42.667 0 000-85.333z"
});

function SvgCoupons(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "coupons_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'CouponsOutlined';

export default KuFoxIcons;
